export const setFtm = (ftm) => {
    localStorage.setItem("ftm", JSON.stringify(ftm));
}

export const getFtm = () => {
    const ftm = JSON.parse(localStorage.getItem("ftm"));
    return ftm;
}

export const removeFtm = () => {
    localStorage.removeItem("ftm");
};